import { render, staticRenderFns } from "./avisoSenha.vue?vue&type=template&id=6b544ec0"
import script from "./avisoSenha.vue?vue&type=script&lang=js"
export * from "./avisoSenha.vue?vue&type=script&lang=js"
import style0 from "./avisoSenha.vue?vue&type=style&index=0&id=6b544ec0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports